window.addEventListener("DOMContentLoaded", function () {
  const mapEl = document.getElementById("google-map");

  if (!mapEl) return;

  const lat = parseFloat(mapEl.dataset.lat);
  const lng = parseFloat(mapEl.dataset.lng);

  const map = new google.maps.Map(mapEl, {
    center: { lat: lat, lng: lng },
    zoom: 14,
    // Disabilita tutte le UI e gesti tranne zoom
    disableDefaultUI: true,
    zoomControl: true,
    gestureHandling: "none", // Disabilita drag, scroll, ecc.
  });

  new google.maps.Marker({
    position: { lat: lat, lng: lng },
    map: map,
  });
});